const {
  useState,
  useMemo
} = React;

/* ===================== SHOPIFY HOOK-UP (set these on the live page) ===================== */
const SHOPIFY = {
  enabled: true,
  variantId: "42441414213714"
};
/* ===================== REAL SWATCH PHOTOS =====================
   Leave empty to use the colour stand-ins. To use real photos, upload each swatch to
   Shopify (Content > Files) and paste its URL keyed by the EXACT shade name, e.g.:
   var SWATCH_IMG = {
  "NOIR": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/NOIR.png?v=1781163517",
  "RAVEN": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/RAVEN.png?v=1781163517",
  "ONYX": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/ONYX.png?v=1781163517",
  "ESPRESSO": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/ESPRESSO.png?v=1781163517",
  "SABLE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/SABLE.png?v=1781163517",
  "CACAO": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/CACAO.png?v=1781163517",
  "MAHOGANY": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/MAHOGANY.png?v=1781163517",
  "CHESTNUT": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/CHESTNUT.png?v=1781163517",
  "WALNUT": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/WALNUT.png?v=1781163517",
  "CEDAR": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/CEDAR.png?v=1781163517",
  "TEAK": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/TEAK.png?v=1781163517",
  "MINK": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/MINK.png?v=1781163517",
  "MALT": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/MALT.png?v=1781163517",
  "TOBACCO": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/TOBACCO.png?v=1781163517",
  "PEBBLE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/PEBBLE.png?v=1781163517",
  "FAWN": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/FAWN.png?v=1781163517",
  "SAND": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/SAND.png?v=1781163517",
  "HARVEST": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/HARVEST.png?v=1781163517",
  "AMBER": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/AMBER.png?v=1781163517",
  "BISCUIT": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/BISCUIT.png?v=1781163517",
  "BUTTER": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/BUTTER.png?v=1781163517",
  "GILDED": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/GILDED.png?v=1781163517",
  "BARLEY": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/BARLEY.png?v=1781163517",
  "HONEY": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/HONEY.png?v=1781163517",
  "SOLEIL": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/SOLEIL.png?v=1781163517",
  "NECTAR": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/NECTAR.png?v=1781163517",
  "TAWNY": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/TAWNY.png?v=1781163517",
  "CINNAMON": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/CINNAMON.png?v=1781163517",
  "COGNAC": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/COGNAC.png?v=1781163517",
  "ROSEWOOD": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/ROSEWOOD.png?v=1781163517",
  "MERLOT": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/MERLOT.png?v=1781163517",
  "GARNET": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/GARNET.png?v=1781163517",
  "VERMEIL": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/VERMEIL.png?v=1781163517",
  "CRIMSON": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/CRIMSON.png?v=1781163517",
  "CHAMPAGNE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/CHAMPAGNE.png?v=1781163517",
  "VANILLA": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/VANILLA.png?v=1781163517",
  "PEARL": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/PEARL.png?v=1781163517",
  "FROST": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/FROST.png?v=1781163517",
  "POLAR": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/POLAR.png?v=1781163517",
  "GLACE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/GLACE.png?v=1781163517",
  "GLACIAL": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/GLACIAL.png?v=1781163517",
  "IVORY": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/IVORY.png?v=1781163517",
  "STERLING": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/STERLING.png?v=1781163517",
  "PEWTER": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/PEWTER.png?v=1781163517",
  "SLATE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/SLATE.png?v=1781163517",
  "FLINT": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/FLINT.png?v=1781163517",
  "DRIFTWOOD": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/DRIFTWOOD.png?v=1781163517",
  "DUNE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/DUNE.png?v=1781163517",
  "LINEN": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/LINEN.png?v=1781163517",
  "OAT": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/OAT.png?v=1781163517",
  "ALABASTER": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/ALABASTER.png?v=1781163517",
  "PARCHMENT": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/PARCHMENT.png?v=1781163517",
  "MARBLE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/MARBLE.png?v=1781163517",
  "QUARTZ": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/QUARTZ.png?v=1781163517",
  "OPAL": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/OPAL.png?v=1781163517",
  "STONE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/STONE.png?v=1781163517",
  "WHEAT": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/WHEAT.png?v=1781163517",
  "FLAX": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/FLAX.png?v=1781163517",
  "HAZEL": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/HAZEL.png?v=1781163517",
  "BRACKEN": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/BRACKEN.png?v=1781163517",
  "SEPIA": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/SEPIA.png?v=1781163517",
  "UMBER": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/UMBER.png?v=1781163517",
  "WREN": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/WREN.png?v=1781163517",
  "PECAN": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/PECAN.png?v=1781163517",
  "BIRCH": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/BIRCH.png?v=1781163517",
  "DUSK": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/DUSK.png?v=1781163517",
  "ECLIPSE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/ECLIPSE.png?v=1781163517",
  "SHADOW": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/SHADOW.png?v=1781163517",
  "MAPLE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/MAPLE.png?v=1781163517",
  "CREAM": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/CREAM.png?v=1781163517",
  "MIST": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/MIST.png?v=1781163517",
  "AURORA": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/AURORA.png?v=1781163517",
  "LUNAR": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/LUNAR.png?v=1781163517",
  "GOSSAMER": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/GOSSAMER.png?v=1781163517",
  "WISP": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/WISP.png?v=1781163517",
  "TOPAZ": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/TOPAZ.png?v=1781163517",
  "OCHRE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/OCHRE.png?v=1781163517",
  "ALMOND": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/ALMOND.png?v=1781163517",
  "TOFFEE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/TOFFEE.png?v=1781163517",
  "SNOW": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/SNOW.png?v=1781163517",
  "PRALINE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/PRALINE.png?v=1781163517",
  "SIENNA": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/SIENNA.png?v=1781163517",
  "JASPER": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/JASPER.png?v=1781163517",
  "HAVANA": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/HAVANA.png?v=1781163517",
  "TRUFFLE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/TRUFFLE.png?v=1781163517"
};;
*/
const SWATCH_IMG = {
  "NOIR": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/NOIR.png?v=1781163517",
  "RAVEN": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/RAVEN.png?v=1781163517",
  "ONYX": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/ONYX.png?v=1781163517",
  "ESPRESSO": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/ESPRESSO.png?v=1781163517",
  "SABLE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/SABLE.png?v=1781163517",
  "CACAO": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/CACAO.png?v=1781163517",
  "MAHOGANY": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/MAHOGANY.png?v=1781163517",
  "CHESTNUT": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/CHESTNUT.png?v=1781163517",
  "WALNUT": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/WALNUT.png?v=1781163517",
  "CEDAR": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/CEDAR.png?v=1781163517",
  "TEAK": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/TEAK.png?v=1781163517",
  "MINK": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/MINK.png?v=1781163517",
  "MALT": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/MALT.png?v=1781163517",
  "TOBACCO": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/TOBACCO.png?v=1781163517",
  "PEBBLE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/PEBBLE.png?v=1781163517",
  "FAWN": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/FAWN.png?v=1781163517",
  "SAND": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/SAND.png?v=1781163517",
  "HARVEST": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/HARVEST.png?v=1781163517",
  "AMBER": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/AMBER.png?v=1781163517",
  "BISCUIT": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/BISCUIT.png?v=1781163517",
  "BUTTER": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/BUTTER.png?v=1781163517",
  "GILDED": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/GILDED.png?v=1781163517",
  "BARLEY": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/BARLEY.png?v=1781163517",
  "HONEY": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/HONEY.png?v=1781163517",
  "SOLEIL": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/SOLEIL.png?v=1781163517",
  "NECTAR": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/NECTAR.png?v=1781163517",
  "TAWNY": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/TAWNY.png?v=1781163517",
  "CINNAMON": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/CINNAMON.png?v=1781163517",
  "COGNAC": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/COGNAC.png?v=1781163517",
  "ROSEWOOD": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/ROSEWOOD.png?v=1781163517",
  "MERLOT": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/MERLOT.png?v=1781163517",
  "GARNET": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/GARNET.png?v=1781163517",
  "VERMEIL": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/VERMEIL.png?v=1781163517",
  "CRIMSON": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/CRIMSON.png?v=1781163517",
  "CHAMPAGNE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/CHAMPAGNE.png?v=1781163517",
  "VANILLA": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/VANILLA.png?v=1781163517",
  "PEARL": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/PEARL.png?v=1781163517",
  "FROST": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/FROST.png?v=1781163517",
  "POLAR": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/POLAR.png?v=1781163517",
  "GLACE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/GLACE.png?v=1781163517",
  "GLACIAL": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/GLACIAL.png?v=1781163517",
  "IVORY": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/IVORY.png?v=1781163517",
  "STERLING": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/STERLING.png?v=1781163517",
  "PEWTER": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/PEWTER.png?v=1781163517",
  "SLATE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/SLATE.png?v=1781163517",
  "FLINT": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/FLINT.png?v=1781163517",
  "DRIFTWOOD": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/DRIFTWOOD.png?v=1781163517",
  "DUNE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/DUNE.png?v=1781163517",
  "LINEN": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/LINEN.png?v=1781163517",
  "OAT": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/OAT.png?v=1781163517",
  "ALABASTER": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/ALABASTER.png?v=1781163517",
  "PARCHMENT": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/PARCHMENT.png?v=1781163517",
  "MARBLE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/MARBLE.png?v=1781163517",
  "QUARTZ": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/QUARTZ.png?v=1781163517",
  "OPAL": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/OPAL.png?v=1781163517",
  "STONE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/STONE.png?v=1781163517",
  "WHEAT": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/WHEAT.png?v=1781163517",
  "FLAX": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/FLAX.png?v=1781163517",
  "HAZEL": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/HAZEL.png?v=1781163517",
  "BRACKEN": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/BRACKEN.png?v=1781163517",
  "SEPIA": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/SEPIA.png?v=1781163517",
  "UMBER": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/UMBER.png?v=1781163517",
  "WREN": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/WREN.png?v=1781163517",
  "PECAN": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/PECAN.png?v=1781163517",
  "BIRCH": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/BIRCH.png?v=1781163517",
  "DUSK": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/DUSK.png?v=1781163517",
  "ECLIPSE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/ECLIPSE.png?v=1781163517",
  "SHADOW": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/SHADOW.png?v=1781163517",
  "MAPLE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/MAPLE.png?v=1781163517",
  "CREAM": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/CREAM.png?v=1781163517",
  "MIST": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/MIST.png?v=1781163517",
  "AURORA": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/AURORA.png?v=1781163517",
  "LUNAR": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/LUNAR.png?v=1781163517",
  "GOSSAMER": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/GOSSAMER.png?v=1781163517",
  "WISP": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/WISP.png?v=1781163517",
  "TOPAZ": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/TOPAZ.png?v=1781163517",
  "OCHRE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/OCHRE.png?v=1781163517",
  "ALMOND": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/ALMOND.png?v=1781163517",
  "TOFFEE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/TOFFEE.png?v=1781163517",
  "SNOW": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/SNOW.png?v=1781163517",
  "PRALINE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/PRALINE.png?v=1781163517",
  "SIENNA": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/SIENNA.png?v=1781163517",
  "JASPER": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/JASPER.png?v=1781163517",
  "HAVANA": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/HAVANA.png?v=1781163517",
  "TRUFFLE": "https://cdn.shopify.com/s/files/1/0593/2515/3362/files/TRUFFLE.png?v=1781163517"
};
const bg = it => SWATCH_IMG[it.name] ? `url('${SWATCH_IMG[it.name]}') center/cover no-repeat` : grad(it.g);
/* ====================================================================================== */

const LOGO = "data:image/png;base64,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";

/* ====================== DATA ====================== */
const SOLIDS = [{
  num: 1,
  name: "NOIR",
  grp: "A",
  grpName: "Black / Off-Black",
  tone: "Jet black",
  band: 0,
  fam: "neutral"
}, {
  num: 2,
  name: "RAVEN",
  grp: "A",
  grpName: "Black / Off-Black",
  tone: "Soft blue-black",
  band: 0,
  fam: "cool"
}, {
  num: 3,
  name: "ONYX",
  grp: "A",
  grpName: "Black / Off-Black",
  tone: "Natural off-black",
  band: 0,
  fam: "neutral"
}, {
  num: 4,
  name: "ESPRESSO",
  grp: "B",
  grpName: "Dark Brown",
  tone: "Darkest brown",
  band: 0,
  fam: "neutral"
}, {
  num: 5,
  name: "SABLE",
  grp: "B",
  grpName: "Dark Brown",
  tone: "Deep cool dark brown",
  band: 0,
  fam: "cool"
}, {
  num: 6,
  name: "CACAO",
  grp: "B",
  grpName: "Dark Brown",
  tone: "Dark chocolate",
  band: 0,
  fam: "neutral"
}, {
  num: 7,
  name: "MAHOGANY",
  grp: "B",
  grpName: "Dark Brown",
  tone: "Warm dark brown / red",
  band: 0,
  fam: "warm"
}, {
  num: 8,
  name: "CHESTNUT",
  grp: "C",
  grpName: "Medium Brown",
  tone: "Medium chestnut",
  band: 1,
  fam: "neutral"
}, {
  num: 9,
  name: "WALNUT",
  grp: "C",
  grpName: "Medium Brown",
  tone: "Neutral medium brown",
  band: 1,
  fam: "neutral"
}, {
  num: 10,
  name: "CEDAR",
  grp: "C",
  grpName: "Medium Brown",
  tone: "Warm medium brown",
  band: 1,
  fam: "warm"
}, {
  num: 11,
  name: "TEAK",
  grp: "C",
  grpName: "Medium Brown",
  tone: "Light-medium brown",
  band: 1,
  fam: "warm"
}, {
  num: 12,
  name: "MINK",
  grp: "D",
  grpName: "Light Brown",
  tone: "Mushroom light-brown",
  band: 2,
  fam: "cool"
}, {
  num: 13,
  name: "MALT",
  grp: "D",
  grpName: "Light Brown",
  tone: "Light golden-brown",
  band: 2,
  fam: "warm"
}, {
  num: 14,
  name: "TOBACCO",
  grp: "D",
  grpName: "Light Brown",
  tone: "Warm light brown",
  band: 2,
  fam: "warm"
}, {
  num: 15,
  name: "PEBBLE",
  grp: "E",
  grpName: "Dark / Ash Blonde",
  tone: "Dark ash blonde",
  band: 2,
  fam: "cool"
}, {
  num: 16,
  name: "FAWN",
  grp: "E",
  grpName: "Dark / Ash Blonde",
  tone: "Light ashy brown-blonde",
  band: 2,
  fam: "cool"
}, {
  num: 17,
  name: "SAND",
  grp: "E",
  grpName: "Dark / Ash Blonde",
  tone: "Neutral dark blonde",
  band: 2,
  fam: "neutral"
}, {
  num: 18,
  name: "HARVEST",
  grp: "E",
  grpName: "Dark / Ash Blonde",
  tone: "Warm dark golden blonde",
  band: 3,
  fam: "warm"
}, {
  num: 19,
  name: "AMBER",
  grp: "F",
  grpName: "Golden / Beige Blonde",
  tone: "Amber golden blonde",
  band: 3,
  fam: "warm"
}, {
  num: 20,
  name: "BISCUIT",
  grp: "F",
  grpName: "Golden / Beige Blonde",
  tone: "Beige-honey blonde",
  band: 3,
  fam: "neutral"
}, {
  num: 21,
  name: "BUTTER",
  grp: "F",
  grpName: "Golden / Beige Blonde",
  tone: "Light buttery blonde",
  band: 3,
  fam: "neutral"
}, {
  num: 22,
  name: "GILDED",
  grp: "F",
  grpName: "Golden / Beige Blonde",
  tone: "Warm golden blonde",
  band: 3,
  fam: "warm"
}, {
  num: 23,
  name: "BARLEY",
  grp: "F",
  grpName: "Golden / Beige Blonde",
  tone: "Golden wheat blonde",
  band: 3,
  fam: "warm"
}, {
  num: 24,
  name: "HONEY",
  grp: "F",
  grpName: "Golden / Beige Blonde",
  tone: "Warm honey blonde",
  band: 3,
  fam: "warm"
}, {
  num: 25,
  name: "SOLEIL",
  grp: "F",
  grpName: "Golden / Beige Blonde",
  tone: "Sunlit golden blonde",
  band: 3,
  fam: "warm"
}, {
  num: 26,
  name: "NECTAR",
  grp: "F",
  grpName: "Golden / Beige Blonde",
  tone: "Golden-strawberry blonde",
  band: 3,
  fam: "warm"
}, {
  num: 27,
  name: "TAWNY",
  grp: "G",
  grpName: "Strawberry / Copper",
  tone: "Strawberry-gold",
  band: 3,
  fam: "warm"
}, {
  num: 28,
  name: "CINNAMON",
  grp: "G",
  grpName: "Strawberry / Copper",
  tone: "Warm copper",
  band: 3,
  fam: "warm"
}, {
  num: 29,
  name: "COGNAC",
  grp: "G",
  grpName: "Strawberry / Copper",
  tone: "Red-copper / auburn",
  band: 2,
  fam: "warm"
}, {
  num: 30,
  name: "ROSEWOOD",
  grp: "G",
  grpName: "Strawberry / Copper",
  tone: "Soft auburn",
  band: 2,
  fam: "warm"
}, {
  num: 31,
  name: "MERLOT",
  grp: "H",
  grpName: "Wine / Red",
  tone: "Deep wine burgundy",
  band: "R",
  fam: "red"
}, {
  num: 32,
  name: "GARNET",
  grp: "H",
  grpName: "Wine / Red",
  tone: "Bright burgundy-red",
  band: "R",
  fam: "red"
}, {
  num: 33,
  name: "VERMEIL",
  grp: "H",
  grpName: "Wine / Red",
  tone: "Vivid jewel red",
  band: "R",
  fam: "red"
}, {
  num: 34,
  name: "CRIMSON",
  grp: "H",
  grpName: "Wine / Red",
  tone: "Bright true red",
  band: "R",
  fam: "red"
}, {
  num: 35,
  name: "CHAMPAGNE",
  grp: "I",
  grpName: "Pale / Light Blonde",
  tone: "Pale warm blonde",
  band: 4,
  fam: "warm"
}, {
  num: 36,
  name: "VANILLA",
  grp: "I",
  grpName: "Pale / Light Blonde",
  tone: "Creamy blonde",
  band: 4,
  fam: "neutral"
}, {
  num: 37,
  name: "PEARL",
  grp: "I",
  grpName: "Pale / Light Blonde",
  tone: "Cool pale blonde",
  band: 4,
  fam: "cool"
}, {
  num: 38,
  name: "FROST",
  grp: "J",
  grpName: "Platinum",
  tone: "Icy white platinum",
  band: 5,
  fam: "cool"
}, {
  num: 39,
  name: "POLAR",
  grp: "J",
  grpName: "Platinum",
  tone: "Bright platinum",
  band: 5,
  fam: "cool"
}, {
  num: 40,
  name: "GLACE",
  grp: "J",
  grpName: "Platinum",
  tone: "Cool platinum",
  band: 5,
  fam: "cool"
}, {
  num: 41,
  name: "GLACIAL",
  grp: "J",
  grpName: "Platinum",
  tone: "Ash platinum",
  band: 5,
  fam: "cool"
}, {
  num: 42,
  name: "IVORY",
  grp: "J",
  grpName: "Platinum",
  tone: "Soft warm white",
  band: 5,
  fam: "neutral"
}, {
  num: 43,
  name: "STERLING",
  grp: "K",
  grpName: "Silver / Grey",
  tone: "Silver",
  band: 5,
  fam: "cool"
}, {
  num: 44,
  name: "PEWTER",
  grp: "K",
  grpName: "Silver / Grey",
  tone: "Grey-silver",
  band: 5,
  fam: "cool"
}, {
  num: 45,
  name: "SLATE",
  grp: "K",
  grpName: "Silver / Grey",
  tone: "Deep silver-grey",
  band: 5,
  fam: "cool"
}, {
  num: 46,
  name: "FLINT",
  grp: "K",
  grpName: "Silver / Grey",
  tone: "Cool grey",
  band: 5,
  fam: "cool"
}];
const DIMS = [{
  num: 47,
  name: "DRIFTWOOD",
  type: "Balayage",
  base: "Ash blonde",
  hi: "Pale blonde",
  band: 2,
  fam: "cool"
}, {
  num: 48,
  name: "DUNE",
  type: "Balayage",
  base: "Sandy blonde",
  hi: "Light blonde",
  band: 3,
  fam: "warm"
}, {
  num: 49,
  name: "LINEN",
  type: "Balayage",
  base: "Neutral blonde",
  hi: "Pale blonde",
  band: 3,
  fam: "neutral"
}, {
  num: 50,
  name: "OAT",
  type: "Balayage",
  base: "Creamy blonde",
  hi: "Light blonde",
  band: 3,
  fam: "neutral"
}, {
  num: 51,
  name: "ALABASTER",
  type: "Balayage",
  base: "Pale blonde",
  hi: "Platinum",
  band: 4,
  fam: "cool"
}, {
  num: 52,
  name: "PARCHMENT",
  type: "Balayage",
  base: "Warm blonde",
  hi: "Light blonde",
  band: 3,
  fam: "warm"
}, {
  num: 53,
  name: "MARBLE",
  type: "Balayage",
  base: "Bright blonde",
  hi: "Platinum",
  band: 3,
  fam: "cool"
}, {
  num: 54,
  name: "QUARTZ",
  type: "Balayage",
  base: "Luminous blonde",
  hi: "Pale blonde",
  band: 3,
  fam: "neutral"
}, {
  num: 55,
  name: "OPAL",
  type: "Balayage",
  base: "Pearl blonde",
  hi: "Pale blonde",
  band: 3,
  fam: "cool"
}, {
  num: 56,
  name: "STONE",
  type: "Balayage",
  base: "Neutral blonde",
  hi: "Light blonde",
  band: 3,
  fam: "neutral"
}, {
  num: 57,
  name: "WHEAT",
  type: "Balayage",
  base: "Golden blonde",
  hi: "Light blonde",
  band: 3,
  fam: "warm"
}, {
  num: 58,
  name: "FLAX",
  type: "Balayage",
  base: "Bronde",
  hi: "Blonde",
  band: 2,
  fam: "neutral"
}, {
  num: 59,
  name: "HAZEL",
  type: "Balayage",
  base: "Warm bronde",
  hi: "Blonde",
  band: 2,
  fam: "warm"
}, {
  num: 60,
  name: "BRACKEN",
  type: "Balayage",
  base: "Medium brown",
  hi: "Blonde",
  band: 1,
  fam: "neutral"
}, {
  num: 61,
  name: "SEPIA",
  type: "Balayage",
  base: "Brown",
  hi: "Ash blonde",
  band: 1,
  fam: "neutral"
}, {
  num: 62,
  name: "UMBER",
  type: "Balayage",
  base: "Deep brown",
  hi: "Blonde ends",
  band: 0,
  fam: "neutral"
}, {
  num: 63,
  name: "WREN",
  type: "Piano",
  base: "Dark blonde",
  hi: "Light blonde",
  band: 2,
  fam: "neutral"
}, {
  num: 64,
  name: "PECAN",
  type: "Piano",
  base: "Light brown",
  hi: "Pale blonde",
  band: 2,
  fam: "neutral"
}, {
  num: 65,
  name: "BIRCH",
  type: "Piano",
  base: "Light brown",
  hi: "Platinum",
  band: 2,
  fam: "cool"
}, {
  num: 66,
  name: "DUSK",
  type: "Ombre",
  base: "Off-black",
  hi: "Warm brown",
  band: 0,
  fam: "neutral"
}, {
  num: 67,
  name: "ECLIPSE",
  type: "Ombre",
  base: "Dark brown",
  hi: "Strawberry-gold",
  band: 0,
  fam: "warm"
}, {
  num: 68,
  name: "SHADOW",
  type: "Piano",
  base: "Natural brown",
  hi: "Brown lowlights",
  band: 1,
  fam: "neutral"
}, {
  num: 69,
  name: "MAPLE",
  type: "Ombre",
  base: "Warm brown",
  hi: "Honey / strawberry",
  band: 0,
  fam: "warm"
}, {
  num: 70,
  name: "CREAM",
  type: "Piano",
  base: "Ash blonde",
  hi: "Pale blonde",
  band: 4,
  fam: "cool"
}, {
  num: 71,
  name: "MIST",
  type: "Piano",
  base: "Ash blonde",
  hi: "Pale blonde",
  band: 4,
  fam: "cool"
}, {
  num: 72,
  name: "AURORA",
  type: "Piano",
  base: "Platinum",
  hi: "Platinum",
  band: 5,
  fam: "cool"
}, {
  num: 73,
  name: "LUNAR",
  type: "Piano",
  base: "Pale blonde",
  hi: "Platinum",
  band: 5,
  fam: "cool"
}, {
  num: 74,
  name: "GOSSAMER",
  type: "Piano",
  base: "Pale blonde",
  hi: "Platinum",
  band: 5,
  fam: "cool"
}, {
  num: 75,
  name: "WISP",
  type: "Piano",
  base: "Light brown",
  hi: "Golden",
  band: 2,
  fam: "warm"
}, {
  num: 76,
  name: "TOPAZ",
  type: "Piano",
  base: "Light brown",
  hi: "Golden",
  band: 2,
  fam: "warm"
}, {
  num: 77,
  name: "OCHRE",
  type: "Piano",
  base: "Golden blonde",
  hi: "Bright blonde",
  band: 3,
  fam: "warm"
}, {
  num: 78,
  name: "ALMOND",
  type: "Piano",
  base: "Light blonde",
  hi: "Pale blonde",
  band: 3,
  fam: "neutral"
}, {
  num: 79,
  name: "TOFFEE",
  type: "Piano",
  base: "Bronde",
  hi: "Gold-strawberry",
  band: 1,
  fam: "warm"
}, {
  num: 80,
  name: "SNOW",
  type: "Piano",
  base: "Ash blonde",
  hi: "Platinum",
  band: 4,
  fam: "cool"
}, {
  num: 81,
  name: "PRALINE",
  type: "Piano",
  base: "Light brown",
  hi: "Caramel / blonde",
  band: 2,
  fam: "warm"
}, {
  num: 82,
  name: "SIENNA",
  type: "Piano",
  base: "Medium brown",
  hi: "Light brown",
  band: 1,
  fam: "neutral"
}, {
  num: 83,
  name: "JASPER",
  type: "Piano",
  base: "Brown",
  hi: "Light brown / ash",
  band: 1,
  fam: "neutral"
}, {
  num: 84,
  name: "HAVANA",
  type: "Piano",
  base: "Dark brown",
  hi: "Strawberry-gold",
  band: 0,
  fam: "warm"
}, {
  num: 85,
  name: "TRUFFLE",
  type: "Piano",
  base: "Darkest brown",
  hi: "Light-brown lowlights",
  band: 0,
  fam: "neutral"
}];
const HEX = {
  1: ["#0d0b0a", "#211c17"],
  2: ["#13151b", "#2a2c35"],
  3: ["#18130f", "#322a22"],
  4: ["#221610", "#3d2a1b"],
  5: ["#241a14", "#3a2a22"],
  6: ["#2a1a10", "#46291a"],
  7: ["#3a1f15", "#5e3220"],
  8: ["#4a2c1c", "#714628"],
  9: ["#4b3526", "#71533b"],
  10: ["#50321f", "#7a512f"],
  11: ["#5d3f28", "#896139"],
  12: ["#6b5947", "#96826c"],
  13: ["#6e4f30", "#9e7a49"],
  14: ["#6b4a2c", "#9c7342"],
  15: ["#7d7259", "#aaa085"],
  16: ["#8a7a60", "#b5a787"],
  17: ["#927d5b", "#c2ac84"],
  18: ["#997040", "#c99c5e"],
  19: ["#a9763a", "#d8a45a"],
  20: ["#b59a6e", "#dfc79c"],
  21: ["#c9ad77", "#eed8a5"],
  22: ["#b48f4e", "#e2bf78"],
  23: ["#b1925a", "#dfc288"],
  24: ["#b3853f", "#e2b76a"],
  25: ["#bf9445", "#edca7a"],
  26: ["#b9824c", "#e5af76"],
  27: ["#b06a3a", "#db9c61"],
  28: ["#9c4f28", "#ca7941"],
  29: ["#7e3a22", "#ac5832"],
  30: ["#864438", "#ad614c"],
  31: ["#4a141c", "#70212b"],
  32: ["#5e131c", "#8e202d"],
  33: ["#7a1414", "#b22525"],
  34: ["#8a0f10", "#c6211f"],
  35: ["#d8c096", "#f2deb8"],
  36: ["#ddc9a0", "#f5e8c6"],
  37: ["#d9cead", "#f3ead4"],
  38: ["#e6e3d9", "#faf8f2"],
  39: ["#e3ddcd", "#f8f3e8"],
  40: ["#dad7ce", "#f2f0ea"],
  41: ["#d2cfc6", "#edebe4"],
  42: ["#e7ddca", "#f9f2e4"],
  43: ["#b9b8b4", "#dadad8"],
  44: ["#a6a5a1", "#c9c8c5"],
  45: ["#8f8e8b", "#b2b1ae"],
  46: ["#9a9a98", "#bebebc"],
  47: ["#8a7c63", "#ddd0b4"],
  48: ["#9a7e54", "#d9c294"],
  49: ["#9e8c6c", "#e0d2b4"],
  50: ["#a18f6b", "#e3d4ad"],
  51: ["#c4b48f", "#efe6cf"],
  52: ["#9c8155", "#ddc999"],
  53: ["#b3a37e", "#ece2cb"],
  54: ["#ab9a76", "#e8dcc0"],
  55: ["#b6a988", "#ebe2cd"],
  56: ["#9d8e6f", "#ddd0b3"],
  57: ["#a5854f", "#ddc28b"],
  58: ["#87724f", "#ccb486"],
  59: ["#7a5e3c", "#c2a06f"],
  60: ["#5f4329", "#b89a6a"],
  61: ["#5a4530", "#a99372"],
  62: ["#3f2c1d", "#9e825a"],
  63: ["#6f5836", "#d9c79a"],
  64: ["#6b543b", "#ddcca7"],
  65: ["#6e5840", "#e2dcc8"],
  66: ["#1c1611", "#5c3a22"],
  67: ["#2c1d14", "#b07440"],
  68: ["#3a2a1d", "#6a4d33"],
  69: ["#3e2616", "#c08a4a"],
  70: ["#b6a988", "#ece0c4"],
  71: ["#b4ab92", "#ebe5d3"],
  72: ["#d8d3c6", "#f4f1ea"],
  73: ["#d2c8ac", "#f1ebd9"],
  74: ["#d5cdb6", "#f3eee1"],
  75: ["#7a6a4f", "#d8c79a"],
  76: ["#74603f", "#d3b878"],
  77: ["#9a7a44", "#e3c886"],
  78: ["#b39c6f", "#e9dcbb"],
  79: ["#6a4c30", "#c79a5f"],
  80: ["#b7af96", "#efe9d8"],
  81: ["#7a5c3a", "#d3b783"],
  82: ["#574027", "#9c7b4f"],
  83: ["#4f3a26", "#a98f66"],
  84: ["#2e1d12", "#b8854a"],
  85: ["#221610", "#5a3f28"]
};
SOLIDS.forEach(s => s.g = HEX[s.num]);
DIMS.forEach(d => d.g = HEX[d.num]);
const LVL = {
  NOIR: 1.0,
  RAVEN: 1.3,
  ONYX: 2.0,
  ESPRESSO: 2.5,
  CACAO: 3.0,
  SABLE: 3.2,
  MAHOGANY: 3.6,
  CHESTNUT: 4.0,
  WALNUT: 4.3,
  CEDAR: 4.6,
  TEAK: 5.0,
  MINK: 5.5,
  MALT: 6.0,
  TOBACCO: 6.3,
  PEBBLE: 6.6,
  FAWN: 6.9,
  SAND: 7.1,
  HARVEST: 7.4,
  AMBER: 7.7,
  HONEY: 7.9,
  BISCUIT: 8.1,
  GILDED: 8.2,
  BARLEY: 8.3,
  SOLEIL: 8.5,
  BUTTER: 8.7,
  CHAMPAGNE: 9.1,
  VANILLA: 9.4,
  PEARL: 9.8,
  IVORY: 10.2,
  GLACIAL: 10.6,
  GLACE: 10.9,
  POLAR: 11.1,
  FROST: 11.4,
  COGNAC: 5.0,
  ROSEWOOD: 5.5,
  CINNAMON: 6.5,
  TAWNY: 7.5,
  NECTAR: 8.0,
  MERLOT: 3.5,
  GARNET: 4.0,
  VERMEIL: 5.0,
  CRIMSON: 5.5,
  SLATE: 7.0,
  PEWTER: 8.0,
  FLINT: 8.5,
  STERLING: 9.0
};
/* ordered tracks (neighbours only come from the same track) */
const TRACKS = {
  "Natural · dark → light": ["NOIR", "RAVEN", "ONYX", "ESPRESSO", "CACAO", "SABLE", "MAHOGANY", "CHESTNUT", "WALNUT", "CEDAR", "TEAK", "MINK", "MALT", "TOBACCO", "PEBBLE", "FAWN", "SAND", "HARVEST", "AMBER", "HONEY", "BISCUIT", "GILDED", "BARLEY", "SOLEIL", "BUTTER", "CHAMPAGNE", "VANILLA", "PEARL", "IVORY", "GLACIAL", "GLACE", "POLAR", "FROST"],
  "Copper & Auburn · dark → light": ["COGNAC", "ROSEWOOD", "CINNAMON", "TAWNY", "NECTAR"],
  "Red & Wine · deep → bright": ["MERLOT", "GARNET", "VERMEIL", "CRIMSON"],
  "Silver & Grey · deep → light": ["SLATE", "PEWTER", "FLINT", "STERLING"]
};
const TRACKOF = {};
Object.entries(TRACKS).forEach(([t, a]) => a.forEach(n => TRACKOF[n] = t));
const BYNAME = {};
SOLIDS.forEach(s => BYNAME[s.name] = s);
/* each blend's base (darker) shade + how light its highlight reads */
const BASEOF = {
  DRIFTWOOD: "PEBBLE",
  DUNE: "SAND",
  LINEN: "SAND",
  OAT: "HARVEST",
  ALABASTER: "CHAMPAGNE",
  PARCHMENT: "HARVEST",
  MARBLE: "BARLEY",
  QUARTZ: "TOBACCO",
  OPAL: "CHAMPAGNE",
  STONE: "SAND",
  WHEAT: "BARLEY",
  FLAX: "MALT",
  HAZEL: "MALT",
  BRACKEN: "CEDAR",
  SEPIA: "WALNUT",
  UMBER: "CACAO",
  WREN: "BARLEY",
  PECAN: "MINK",
  BIRCH: "TEAK",
  DUSK: "ONYX",
  ECLIPSE: "MAHOGANY",
  SHADOW: "WALNUT",
  MAPLE: "MAHOGANY",
  CREAM: "PEARL",
  MIST: "GLACE",
  AURORA: "POLAR",
  LUNAR: "PEARL",
  GOSSAMER: "PEARL",
  WISP: "MALT",
  TOPAZ: "MALT",
  OCHRE: "GILDED",
  ALMOND: "AMBER",
  TOFFEE: "WALNUT",
  SNOW: "PEBBLE",
  PRALINE: "MALT",
  SIENNA: "WALNUT",
  JASPER: "WALNUT",
  HAVANA: "MAHOGANY",
  TRUFFLE: "ESPRESSO"
};
const HILVL = {
  DRIFTWOOD: 9.5,
  DUNE: 8.5,
  LINEN: 9.0,
  OAT: 9.0,
  ALABASTER: 10.5,
  PARCHMENT: 8.8,
  MARBLE: 10.0,
  QUARTZ: 9.0,
  OPAL: 9.5,
  STONE: 8.8,
  WHEAT: 8.8,
  FLAX: 8.0,
  HAZEL: 8.0,
  BRACKEN: 8.0,
  SEPIA: 7.5,
  UMBER: 8.0,
  WREN: 9.0,
  PECAN: 9.5,
  BIRCH: 10.0,
  DUSK: 4.0,
  ECLIPSE: 7.5,
  SHADOW: 5.0,
  MAPLE: 7.5,
  CREAM: 9.8,
  MIST: 10.5,
  AURORA: 11.0,
  LUNAR: 10.5,
  GOSSAMER: 10.5,
  WISP: 8.0,
  TOPAZ: 8.0,
  OCHRE: 9.0,
  ALMOND: 9.0,
  TOFFEE: 7.5,
  SNOW: 10.0,
  PRALINE: 8.5,
  SIENNA: 6.0,
  JASPER: 6.5,
  HAVANA: 7.5,
  TRUFFLE: 4.5
};
const LIFTCAP = 4.5; // a blend won't be offered if its highlight is more than this many levels lighter than the anchor

/* ---- Find-your-anchor guide ---- */
const HLOPT = [["yes", "Yes — balayage / highlights"], ["no", "No — one solid colour"]];
const DEPTHS = [["black", "Black"], ["darkbrown", "Dark brown"], ["medbrown", "Medium brown"], ["ltbrown", "Light brown"], ["darkblonde", "Dark blonde"], ["blonde", "Blonde"], ["pale", "Pale / platinum"], ["silver", "Silver / grey"], ["redcopper", "Red / copper / auburn"]];
const TONES = [["warm", "Warm (golden / red)"], ["neutral", "Neutral"], ["cool", "Cool (ashy)"]];
const NATTRACK = "Natural · dark → light";
const DEPTHMAP = {
  black: 1.3,
  darkbrown: 3.0,
  medbrown: 4.4,
  ltbrown: 5.8,
  darkblonde: 7.0,
  blonde: 8.2,
  pale: 10.2
};
function findAnchors(q) {
  if (!q || !q.depth) return [];
  if (q.depth === "silver") return ["SLATE", "PEWTER", "FLINT", "STERLING"].map(n => BYNAME[n]).filter(Boolean);
  if (q.depth === "redcopper") return ["COGNAC", "ROSEWOOD", "CINNAMON", "TAWNY", "MERLOT", "GARNET", "VERMEIL", "CRIMSON"].map(n => BYNAME[n]).filter(Boolean);
  const target = DEPTHMAP[q.depth];
  if (target == null) return [];
  const tone = q.tone;
  const cand = TRACKS[NATTRACK].map(n => BYNAME[n]).filter(s => Math.abs(LVL[s.name] - target) <= 1.4);
  const score = s => {
    const fm = s.fam === tone ? 0 : s.fam === "neutral" || tone === "neutral" || !tone ? 0.5 : 1.2;
    return fm + Math.abs(LVL[s.name] - target) * 0.25;
  };
  return cand.sort((a, b) => score(a) - score(b)).slice(0, 3);
}
const GROUP_ORDER = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K"];
const famOk = (a, d) => a === "neutral" || d === "neutral" || a === d;
const bandOk = (a, d) => a !== "R" && d !== "R" && Math.abs(a - d) <= 2;
const matchDim = (anchor, d) => bandOk(anchor.band, d.band) && famOk(anchor.fam, d.fam);

/* ===== THEME TOKENS ===== */
const C = {
  bg: "#FFFFFF",
  panel: "#F8F8F7",
  ink: "#000000",
  soft: "#6B6B6B",
  line: "#E2E2E2",
  gold: "#262626",
  goldSoft: "#EDEDED",
  chip: "#FFFFFF"
};
const grad = g => `repeating-linear-gradient(95deg, rgba(255,255,255,.07) 0px, rgba(0,0,0,.05) 1px, transparent 2px, transparent 4px), linear-gradient(180deg, ${g[0]} 0%, ${g[0]} 20%, ${g[1]} 100%)`;

/* ====================== APP ====================== */
function App() {
  const [anchor, setAnchor] = useState(null);
  const [companions, setCompanions] = useState([]);
  const [dims, setDims] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [added, setAdded] = useState(false);
  const [findMode, setFindMode] = useState(true);
  const [q, setQ] = useState({});
  const groups = useMemo(() => {
    const g = {};
    SOLIDS.forEach(s => {
      (g[s.grp] = g[s.grp] || {
        name: s.grpName,
        items: []
      }).items.push(s);
    });
    return g;
  }, []);
  const inKit = it => companions.some(x => x.num === it.num) || dims.some(x => x.num === it.num) || anchor && anchor.num === it.num;
  const track = anchor ? TRACKOF[anchor.name] : null;
  const arr = track ? TRACKS[track] : [];
  const ai = anchor ? arr.indexOf(anchor.name) : -1;
  const darkerOpts = anchor ? [arr[ai - 1], arr[ai - 2]].filter(Boolean).map(n => BYNAME[n]) : [];
  const lighterOpts = anchor ? [arr[ai + 1], arr[ai + 2]].filter(Boolean).map(n => BYNAME[n]) : [];
  const window5 = anchor ? [anchor.name, ...darkerOpts.map(s => s.name), ...lighterOpts.map(s => s.name)] : [];
  const blendOpts = anchor ? DIMS.filter(d => window5.includes(BASEOF[d.name]) && HILVL[d.name] - LVL[anchor.name] <= LIFTCAP) : [];
  const toggleC = s => setCompanions(p => {
    const has = p.some(x => x.num === s.num);
    if (has) return p.filter(x => x.num !== s.num);
    if (1 + p.length + dims.length >= 3) return p;
    return [...p, s];
  });
  const toggleD = d => setDims(p => {
    const has = p.some(x => x.num === d.num);
    if (has) return p.filter(x => x.num !== d.num);
    if (1 + companions.length + p.length >= 3) return p;
    return [...p, d];
  });
  const pickAnchor = s => {
    setAnchor(s);
    setCompanions([]);
    setDims([]);
    setShowAll(false);
    setAdded(false);
  };
  const pickDim = d => {
    const base = BYNAME[BASEOF[d.name]];
    if (!base) return;
    pickAnchor(base);
    setDims([d]);
  };
  const reset = () => {
    setAnchor(null);
    setCompanions([]);
    setDims([]);
    setAdded(false);
    setQ({});
    setFindMode(true);
  };
  const kit = [anchor, ...companions, ...dims].filter(Boolean);
  const full = kit.length >= 3;
  const addKit = async () => {
    if (SHOPIFY.enabled && SHOPIFY.variantId) {
      const props = {};
      kit.forEach((it, i) => {
        const role = it === anchor ? "Anchor" : it.type ? "Blend (" + it.type + ")" : "Shade";
        props[role + (props[role] ? " " + i : "")] = it.name;
      });
      try {
        const r = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            items: [{
              id: SHOPIFY.variantId,
              quantity: 1,
              properties: props
            }]
          })
        });
        if (r.ok) {
          window.location.href = "/cart";
        } else {
          let msg = "Could not add the kit to your cart.";
          try {
            const err = await r.json();
            msg = err.description || err.message || msg;
          } catch (e2) {}
          alert(msg + " Please email info@alio.co.za if this continues.");
        }
      } catch (e) {
        alert("Connection issue \u2014 the kit was not added. Please try again.");
      }
    } else {
      setAdded(true);
    }
  };
  const downloadPNG = async () => {
    if (!anchor) return;
    if (document.fonts && document.fonts.ready) {
      try {
        await document.fonts.ready;
      } catch (e) {}
    }
    const logo = new Image();
    logo.src = LOGO;
    try {
      await logo.decode();
    } catch (e) {}
    const swatchImgs = {};
    await Promise.all(kit.map(async it => {
      if (SWATCH_IMG[it.name]) {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.src = SWATCH_IMG[it.name];
        try {
          await img.decode();
          swatchImgs[it.name] = img;
        } catch (e) {}
      }
    }));
    const W = 1080,
      H = 1350,
      cv = document.createElement("canvas");
    cv.width = W;
    cv.height = H;
    const x = cv.getContext("2d");
    x.fillStyle = "#FFFFFF";
    x.fillRect(0, 0, W, H);
    x.textAlign = "center";
    x.textBaseline = "alphabetic";
    const lw = 300,
      lh = logo.width ? logo.height * lw / logo.width : 113;
    x.drawImage(logo, (W - lw) / 2, 70, lw, lh);
    x.fillStyle = "#6B6B6B";
    x.font = "400 24px 'Outfit', Arial, sans-serif";
    if ("letterSpacing" in x) x.letterSpacing = "7px";
    x.fillText("MY SHADE EDIT", W / 2, 70 + lh + 34);
    if ("letterSpacing" in x) x.letterSpacing = "0px";
    const margin = 120,
      gap = 28,
      n = kit.length,
      contentW = W - 2 * margin;
    const swW = (contentW - (n - 1) * gap) / n,
      swTop = 300,
      swH = 600,
      swBottom = swTop + swH,
      r = 20;
    const rr = (c, X, Y, w, h, rad) => {
      c.beginPath();
      c.moveTo(X + rad, Y);
      c.arcTo(X + w, Y, X + w, Y + h, rad);
      c.arcTo(X + w, Y + h, X, Y + h, rad);
      c.arcTo(X, Y + h, X, Y, rad);
      c.arcTo(X, Y, X + w, Y, rad);
      c.closePath();
    };
    kit.forEach((it, i) => {
      const sx = margin + i * (swW + gap);
      if (swatchImgs[it.name]) {
        rr(x, sx, swTop, swW, swH, r);
        x.save();
        x.clip();
        x.drawImage(swatchImgs[it.name], sx, swTop, swW, swH);
        x.restore();
      } else {
        const g = x.createLinearGradient(0, swTop, 0, swBottom);
        g.addColorStop(0, it.g[0]);
        g.addColorStop(.18, it.g[0]);
        g.addColorStop(1, it.g[1]);
        rr(x, sx, swTop, swW, swH, r);
        x.fillStyle = g;
        x.fill();
      }
      const sh = x.createLinearGradient(0, swBottom - 130, 0, swBottom);
      sh.addColorStop(0, "rgba(0,0,0,0)");
      sh.addColorStop(1, "rgba(0,0,0,0.14)");
      rr(x, sx, swTop, swW, swH, r);
      x.fillStyle = sh;
      x.fill();
      x.fillStyle = "#000";
      x.font = "600 36px 'Outfit', Arial, sans-serif";
      x.fillText(it.name, sx + swW / 2, swBottom + 58);
      const role = it === anchor ? "ANCHOR" : it.type ? it.type.toUpperCase() : "SHADE";
      x.fillStyle = "#6B6B6B";
      x.font = "400 22px 'Outfit', Arial, sans-serif";
      x.fillText(role, sx + swW / 2, swBottom + 92);
    });
    const fw = 120,
      fh = logo.width ? logo.height * fw / logo.width : 45,
      fy = swBottom + 150;
    x.drawImage(logo, (W - fw) / 2, fy, fw, fh);
    const globe = (c, gx, gy, s) => {
      c.save();
      c.strokeStyle = "#000";
      c.lineWidth = Math.max(1.6, s * 0.06);
      c.beginPath();
      c.arc(gx + s / 2, gy + s / 2, s / 2, 0, Math.PI * 2);
      c.stroke();
      c.beginPath();
      c.ellipse(gx + s / 2, gy + s / 2, s * 0.22, s / 2, 0, 0, Math.PI * 2);
      c.stroke();
      c.beginPath();
      c.moveTo(gx, gy + s / 2);
      c.lineTo(gx + s, gy + s / 2);
      c.moveTo(gx + s * 0.08, gy + s * 0.28);
      c.lineTo(gx + s * 0.92, gy + s * 0.28);
      c.moveTo(gx + s * 0.08, gy + s * 0.72);
      c.lineTo(gx + s * 0.92, gy + s * 0.72);
      c.stroke();
      c.restore();
    };
    const ig = (c, ix, iy, s) => {
      c.save();
      c.strokeStyle = "#000";
      c.lineWidth = Math.max(1.8, s * 0.08);
      const rad = s * 0.28;
      c.beginPath();
      c.moveTo(ix + rad, iy);
      c.arcTo(ix + s, iy, ix + s, iy + s, rad);
      c.arcTo(ix + s, iy + s, ix, iy + s, rad);
      c.arcTo(ix, iy + s, ix, iy, rad);
      c.arcTo(ix, iy, ix + s, iy, rad);
      c.closePath();
      c.stroke();
      c.beginPath();
      c.arc(ix + s / 2, iy + s / 2, s * 0.26, 0, Math.PI * 2);
      c.stroke();
      c.beginPath();
      c.arc(ix + s * 0.74, iy + s * 0.26, s * 0.055, 0, Math.PI * 2);
      c.fillStyle = "#000";
      c.fill();
      c.restore();
    };
    const row = (iconFn, label, cy) => {
      x.font = "400 26px 'Outfit', Arial, sans-serif";
      x.textBaseline = "middle";
      const tw = x.measureText(label).width,
        isz = 30,
        g2 = 12,
        total = isz + g2 + tw,
        sx0 = (W - total) / 2;
      iconFn(x, sx0, cy - isz / 2, isz);
      x.textAlign = "left";
      x.fillStyle = "#000";
      x.fillText(label, sx0 + isz + g2, cy);
      x.textAlign = "center";
    };
    row(globe, "alio.co.za", fy + fh + 46);
    row(ig, "@alio_aera", fy + fh + 92);
    x.textBaseline = "alphabetic";
    x.fillStyle = "#000";
    x.font = "500 28px 'Outfit', Arial, sans-serif";
    if ("letterSpacing" in x) x.letterSpacing = "4px";
    x.fillText("#ALIOAERA", W / 2, fy + fh + 152);
    if ("letterSpacing" in x) x.letterSpacing = "0px";
    const fname = `alio-${anchor.name.toLowerCase()}-edit.png`;
    const save = url => {
      const a = document.createElement("a");
      a.href = url;
      a.download = fname;
      a.rel = "noopener";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    };
    try {
      if (cv.toBlob) {
        cv.toBlob(b => {
          if (!b) {
            save(cv.toDataURL("image/png"));
            return;
          }
          const u = URL.createObjectURL(b);
          save(u);
          setTimeout(() => URL.revokeObjectURL(u), 4000);
        }, "image/png");
      } else {
        save(cv.toDataURL("image/png"));
      }
    } catch (e) {
      try {
        const w = window.open("about:blank", "_blank");
        if (w) {
          w.document.write('<img src="' + cv.toDataURL("image/png") + '" style="max-width:100%">');
        } else {
          alert("Your browser blocked the download \u2014 please try again in Safari or Chrome at alio.co.za.");
        }
      } catch (e2) {
        alert("Your browser blocked the download \u2014 please try again in Safari or Chrome at alio.co.za.");
      }
    }
  };
  const roleOf = it => it === anchor ? "ANCHOR" : dims.some(x => x.num === it.num) ? it.type.toUpperCase() : "SHADE";
  return /*#__PURE__*/React.createElement("div", {
    style: {
      minHeight: "100vh",
      background: C.bg,
      color: C.ink,
      fontFamily: "'Outfit',sans-serif"
    }
  }, /*#__PURE__*/React.createElement("style", null, `@import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,500;9..144,600&family=Outfit:wght@300;400;500;600&display=swap');
      *{box-sizing:border-box} button{font-family:inherit;cursor:pointer;color:inherit}
      @keyframes rise{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}
      .rise{animation:rise .4s ease both}
      .wrap{display:flex;gap:22px;align-items:flex-start;flex-wrap:wrap;max-width:1040px;margin:0 auto;padding:22px}
      .main{flex:1 1 360px;min-width:300px}
      .kit{flex:1 1 270px;min-width:250px}
      @media(min-width:820px){.kit{position:sticky;top:14px}}`), /*#__PURE__*/React.createElement("div", {
    style: {
      borderBottom: `1px solid ${C.line}`,
      padding: "20px 24px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: 10
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: LOGO,
    alt: "ALIO",
    style: {
      height: 24,
      display: "block"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 11,
      letterSpacing: 3,
      color: C.soft,
      textTransform: "uppercase"
    }
  }, "Build Your Kit"))), /*#__PURE__*/React.createElement("div", {
    className: "wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "main rise"
  }, !anchor && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(H, null, "Find your anchor shade"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 8,
      marginTop: 12
    }
  }, /*#__PURE__*/React.createElement(Toggle, {
    on: findMode,
    onClick: () => setFindMode(true)
  }, "Help me find it"), /*#__PURE__*/React.createElement(Toggle, {
    on: !findMode,
    onClick: () => setFindMode(false)
  }, "Browse all shades")), findMode ? /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 14
    }
  }, /*#__PURE__*/React.createElement(P, null, "A couple of quick questions point you to your anchor \u2014 your base or root colour. The kit builds out from there."), /*#__PURE__*/React.createElement(OptionRow, {
    label: "Do you already have highlights or balayage?",
    opts: HLOPT,
    val: q.hl,
    onPick: v => setQ(p => ({
      ...p,
      hl: v
    }))
  }), /*#__PURE__*/React.createElement(OptionRow, {
    label: "How deep is your base / roots?",
    opts: DEPTHS,
    val: q.depth,
    onPick: v => setQ(p => ({
      ...p,
      depth: v,
      ...(v === "silver" || v === "redcopper" ? {
        tone: undefined
      } : {})
    }))
  }), q.depth && q.depth !== "silver" && q.depth !== "redcopper" && /*#__PURE__*/React.createElement(OptionRow, {
    label: "What's your undertone?",
    opts: TONES,
    val: q.tone,
    onPick: v => setQ(p => ({
      ...p,
      tone: v
    }))
  }), (() => {
    const ready = q.depth && (q.depth === "silver" || q.depth === "redcopper" || q.tone);
    if (!ready) return null;
    const res = findAnchors(q);
    return /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 22
      }
    }, /*#__PURE__*/React.createElement(SubLabel, null, q.hl === "yes" ? "YOUR BASE / ANCHOR MATCH" : "YOUR ANCHOR MATCH"), res.length ? /*#__PURE__*/React.createElement(Grid, null, res.map((s, i) => /*#__PURE__*/React.createElement(Tile, {
      key: s.num,
      it: s,
      onClick: () => pickAnchor(s),
      sug: i === 0
    }))) : /*#__PURE__*/React.createElement(Note, null, "Try different options above."), q.hl === "yes" && /*#__PURE__*/React.createElement(Note, null, "Your highlights are the lighter pieces. Pick your base above \u2014 the builder then shows the balayage & piano blends that match it."), /*#__PURE__*/React.createElement(Note, null, "Tap a shade to start building", res.length > 1 ? " — the first is the closest match." : "."));
  })()) : /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 6
    }
  }, /*#__PURE__*/React.createElement(P, null, "The colour your kit is built around \u2014 pick one to see its options. Your kit is 3 colours in total."), GROUP_ORDER.map(g => /*#__PURE__*/React.createElement("div", {
    key: g,
    style: {
      marginTop: 20
    }
  }, /*#__PURE__*/React.createElement(GroupLabel, null, g, " \xB7 ", groups[g].name), /*#__PURE__*/React.createElement(Grid, null, groups[g].items.map(s => /*#__PURE__*/React.createElement(Tile, {
    key: s.num,
    it: s,
    onClick: () => pickAnchor(s)
  }))))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 26,
      borderTop: `1px solid ${C.line}`,
      paddingTop: 10
    }
  }, /*#__PURE__*/React.createElement(GroupLabel, null, "DIMENSIONAL \xB7 Piano, Ombr\xE9 & Balayage"), /*#__PURE__*/React.createElement(P, null, "Blended shades with a darker base and lighter lengths. Tap one \u2014 the builder starts your kit on its base shade with the blend already added."), [["Piano", "PIANO"], ["Ombre", "OMBR\xC9"], ["Balayage", "BALAYAGE"]].map(([t, label]) => /*#__PURE__*/React.createElement("div", {
    key: t,
    style: {
      marginTop: 20
    }
  }, /*#__PURE__*/React.createElement(GroupLabel, null, label), /*#__PURE__*/React.createElement(Grid, null, DIMS.filter(d => d.type === t).map(d => /*#__PURE__*/React.createElement(Tile, {
    key: d.num,
    it: d,
    dim: true,
    onClick: () => pickDim(d)
  })))))))), anchor && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "baseline",
      flexWrap: "wrap",
      gap: 8
    }
  }, /*#__PURE__*/React.createElement(H, null, "Build around ", anchor.name), /*#__PURE__*/React.createElement("button", {
    onClick: reset,
    style: textBtn
  }, "\u2190 change anchor")), /*#__PURE__*/React.createElement(P, null, "Your kit is ", /*#__PURE__*/React.createElement("b", null, "3 colours total"), " \u2014 your anchor plus up to 2 of the shades sitting next to it on the ladder (max 2 lighter, 2 darker). Or add an optional blend that is built on one of those shades."), full && /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 11.5,
      color: C.ink,
      background: C.goldSoft,
      borderRadius: 8,
      padding: "7px 11px",
      marginTop: 10,
      display: "inline-block"
    }
  }, "Kit full \xB7 3 colours max \u2014 remove one to swap."), /*#__PURE__*/React.createElement(Section, {
    label: "Choose a lighter shade",
    count: lighterOpts.length
  }, lighterOpts.length ? /*#__PURE__*/React.createElement(Grid, null, lighterOpts.map(s => /*#__PURE__*/React.createElement(Tile, {
    key: s.num,
    it: s,
    sel: companions.some(x => x.num === s.num),
    onClick: () => toggleC(s),
    disabled: full && !companions.some(x => x.num === s.num)
  }))) : /*#__PURE__*/React.createElement(Note, null, anchor.name, " sits at the lightest end of its range \u2014 no lighter shade to add.")), /*#__PURE__*/React.createElement(Section, {
    label: "Choose a darker shade",
    count: darkerOpts.length
  }, darkerOpts.length ? /*#__PURE__*/React.createElement(Grid, null, darkerOpts.map(s => /*#__PURE__*/React.createElement(Tile, {
    key: s.num,
    it: s,
    sel: companions.some(x => x.num === s.num),
    onClick: () => toggleC(s),
    disabled: full && !companions.some(x => x.num === s.num)
  }))) : /*#__PURE__*/React.createElement(Note, null, anchor.name, " sits at the darkest end of its range \u2014 no darker shade to add.")), /*#__PURE__*/React.createElement(Section, {
    label: `Blends that work with ${anchor.name}`,
    count: blendOpts.length,
    sub: "Optional \xB7 light part = highlight, dark part = base"
  }, blendOpts.length ? /*#__PURE__*/React.createElement(Grid, null, blendOpts.map(d => /*#__PURE__*/React.createElement(Tile, {
    key: d.num,
    it: d,
    dim: true,
    sel: dims.some(x => x.num === d.num),
    onClick: () => toggleD(d),
    disabled: full && !dims.some(x => x.num === d.num)
  }))) : /*#__PURE__*/React.createElement(Note, null, "No blend pairs with this shade \u2014 add another shade instead.")))), anchor && /*#__PURE__*/React.createElement("div", {
    className: "kit rise"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      ...card(),
      padding: 16
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "'Fraunces',serif",
      fontSize: 18
    }
  }, anchor.name, " Kit"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 11,
      color: C.soft,
      letterSpacing: .5
    }
  }, kit.length, " of 3 swatches \xB7 seen together"), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 14
    }
  }, /*#__PURE__*/React.createElement(FinishedLook, {
    kit: kit
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 6,
      marginTop: 12,
      flexWrap: "wrap"
    }
  }, kit.map((it, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    style: {
      width: 54,
      position: "relative"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: 74,
      borderRadius: 7,
      background: bg(it),
      border: `1px solid ${C.line}`,
      boxShadow: "inset 0 -8px 14px rgba(0,0,0,.12)"
    }
  }), /*#__PURE__*/React.createElement("button", {
    onClick: () => {
      if (it === anchor) {
        reset();
      } else if (dims.some(x => x.num === it.num)) {
        toggleD(it);
      } else {
        toggleC(it);
      }
    },
    style: {
      position: "absolute",
      top: -6,
      right: -6,
      width: 18,
      height: 18,
      borderRadius: 9,
      border: "none",
      background: C.ink,
      color: C.bg,
      fontSize: 11,
      lineHeight: "16px"
    }
  }, "\xD7"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 9,
      textAlign: "center",
      marginTop: 3,
      letterSpacing: .3
    }
  }, it.name), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 8,
      textAlign: "center",
      color: C.gold,
      letterSpacing: .5
    }
  }, roleOf(it))))), !added ? /*#__PURE__*/React.createElement("button", {
    onClick: addKit,
    style: {
      width: "100%",
      marginTop: 14,
      background: C.ink,
      border: "none",
      borderRadius: 30,
      padding: "12px",
      color: C.bg,
      fontSize: 13,
      letterSpacing: 1
    }
  }, "Add this kit to my cart") : /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 14,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      background: C.goldSoft,
      borderRadius: 10,
      padding: "10px",
      fontSize: 13
    }
  }, "\u2713 ", anchor.name, " Kit added \xB7 ", kit.length, " pieces"), /*#__PURE__*/React.createElement("button", {
    onClick: reset,
    style: {
      ...textBtn,
      marginTop: 8
    }
  }, "build another kit \u21BA")), /*#__PURE__*/React.createElement("button", {
    onClick: downloadPNG,
    style: {
      width: "100%",
      marginTop: 8,
      background: "transparent",
      border: `1px solid ${C.ink}`,
      borderRadius: 30,
      padding: "11px",
      color: C.ink,
      fontSize: 13,
      letterSpacing: .5
    }
  }, "\u2193 Download my swatch edit")))));
}

/* ---------- bits ---------- */
const H = ({
  children
}) => /*#__PURE__*/React.createElement("div", {
  style: {
    fontFamily: "'Fraunces',serif",
    fontSize: 27,
    fontWeight: 500
  }
}, children);
const P = ({
  children
}) => /*#__PURE__*/React.createElement("div", {
  style: {
    color: C.soft,
    fontSize: 13.5,
    marginTop: 6,
    maxWidth: 560,
    lineHeight: 1.5
  }
}, children);
const GroupLabel = ({
  children
}) => /*#__PURE__*/React.createElement("div", {
  style: {
    fontSize: 11.5,
    letterSpacing: 2,
    color: C.gold,
    textTransform: "uppercase",
    borderBottom: `1px solid ${C.line}`,
    paddingBottom: 6
  }
}, children);
const SubLabel = ({
  children
}) => /*#__PURE__*/React.createElement("div", {
  style: {
    fontSize: 10.5,
    letterSpacing: 1.5,
    color: C.soft,
    marginTop: 14,
    marginBottom: 2
  }
}, children);
const Empty = ({
  children
}) => /*#__PURE__*/React.createElement("div", {
  style: {
    fontSize: 12.5,
    color: C.soft,
    fontStyle: "italic",
    marginTop: 6
  }
}, children);
function Section({
  label,
  count,
  sub,
  children
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 24
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 11.5,
      letterSpacing: 2,
      color: C.ink,
      textTransform: "uppercase",
      borderBottom: `1px solid ${C.line}`,
      paddingBottom: 6
    }
  }, label, count != null && /*#__PURE__*/React.createElement("span", {
    style: {
      color: C.soft,
      fontWeight: 400
    }
  }, " \xB7 ", count)), sub && /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 11.5,
      color: C.soft,
      marginTop: 6
    }
  }, sub), children);
}
function Note({
  children
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12.5,
      color: C.soft,
      fontStyle: "italic",
      marginTop: 8
    }
  }, children);
}
function OptionRow({
  label,
  opts,
  val,
  onPick
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 16
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12.5,
      letterSpacing: .3,
      color: C.ink,
      marginBottom: 8,
      fontWeight: 600
    }
  }, label), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexWrap: "wrap",
      gap: 8
    }
  }, opts.map(([v, lab]) => /*#__PURE__*/React.createElement("button", {
    key: v,
    onClick: () => onPick(v),
    style: {
      borderRadius: 30,
      padding: "8px 14px",
      fontSize: 12.5,
      border: `1px solid ${val === v ? C.gold : C.line}`,
      background: val === v ? C.goldSoft : C.chip,
      color: C.ink
    }
  }, lab))));
}
const Grid = ({
  children
}) => /*#__PURE__*/React.createElement("div", {
  style: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill,minmax(78px,1fr))",
    gap: 10,
    marginTop: 10
  }
}, children);
const card = () => ({
  background: C.panel,
  border: `1px solid ${C.line}`,
  borderRadius: 12
});
const textBtn = {
  background: "transparent",
  border: "none",
  color: C.soft,
  fontSize: 12,
  textDecoration: "underline",
  padding: 0
};
function Toggle({
  on,
  onClick,
  children
}) {
  return /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    style: {
      borderRadius: 30,
      padding: "6px 13px",
      fontSize: 12,
      border: `1px solid ${on ? C.gold : C.line}`,
      background: on ? C.goldSoft : C.chip,
      color: on ? C.gold : C.soft
    }
  }, children);
}
function Tile({
  it,
  sel,
  onClick,
  dim,
  sug,
  disabled
}) {
  return /*#__PURE__*/React.createElement("button", {
    onClick: disabled ? undefined : onClick,
    disabled: disabled,
    style: {
      padding: 0,
      border: "none",
      background: "none",
      textAlign: "left",
      position: "relative",
      opacity: disabled ? 0.32 : 1,
      cursor: disabled ? "default" : "pointer"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: 84,
      borderRadius: 8,
      background: bg(it),
      border: `2px solid ${sel ? C.gold : C.line}`,
      boxShadow: sel ? `0 0 0 3px ${C.goldSoft}` : "inset 0 -10px 16px rgba(0,0,0,.13)"
    }
  }), sug && !sel && /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      top: 5,
      left: 5,
      fontSize: 8,
      background: "rgba(245,239,230,.92)",
      color: "#2B2722",
      borderRadius: 4,
      padding: "1px 4px",
      letterSpacing: .5
    }
  }, "SUGGESTED"), sel && /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      top: 5,
      right: 5,
      width: 18,
      height: 18,
      borderRadius: 9,
      background: C.gold,
      color: "#fff",
      fontSize: 12,
      lineHeight: "18px",
      textAlign: "center"
    }
  }, "\u2713"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 11,
      fontWeight: 600,
      marginTop: 4,
      letterSpacing: .3
    }
  }, it.name), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 9.5,
      color: C.soft,
      lineHeight: 1.25
    }
  }, dim ? `${it.base} + ${it.hi}` : it.tone));
}
function FinishedLook({
  kit
}) {
  if (!kit.length) return null;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 14
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 10.5,
      letterSpacing: 1.5,
      color: C.gold
    }
  }, "SWATCHES TOGETHER"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 3,
      height: 210,
      marginTop: 6,
      borderRadius: 10,
      overflow: "hidden",
      border: `1px solid ${C.line}`,
      background: C.panel
    }
  }, kit.map((it, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    style: {
      flex: 1,
      position: "relative",
      background: bg(it),
      boxShadow: "inset 0 -14px 22px rgba(0,0,0,.13)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      padding: "5px 2px",
      textAlign: "center",
      fontSize: 9,
      letterSpacing: .4,
      background: "linear-gradient(180deg,rgba(0,0,0,0) 0%,rgba(0,0,0,.32) 100%)",
      color: "#fff"
    }
  }, it.name)))), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 9.5,
      color: C.soft,
      marginTop: 3
    }
  }, ""));
}
const _root = ReactDOM.createRoot(document.getElementById("alio-kit-root"));
_root.render(React.createElement(App));